import React from "react";
import { Container, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import { connect } from "react-redux";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import PageModal from "presentation/components/page-modal";

import DropdownMenu from "presentation/components/dropdown-menu/menu";
import EditItemTitle from "presentation/components/dropdown-menu/item-title/edit";
import RemoveItemTitle from "presentation/components/dropdown-menu/item-title/remove";
import { DROPDOWN_MENU_TYPE_ITEM, DROPDOWN_MENU_TYPE_DIVIDER } from 'presentation/model/constants';

import CancelButton from "presentation/components/buttons/cancel";
import AddButton from "presentation/components/buttons/add";


import ResponsiblesLookUpModal from "presentation/pages/responsibles/elements/responsibles-lookup-modal";

import { handleResultData } from "presentation/utils/functions/generic";

import responsiblesService from "presentation/services/responsibles";
import studentsService from "presentation/services/students";
import { PersonLock } from "react-bootstrap-icons";

class ResponsibleMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      actionLoading: false,
      error: false,
      message: '',
      dependentName: '',
      dependentRegistration: '',
      data: [],
      showConfirmModal: false,
      showPersonLookUpModal: false,
      targetDeleteId: null,
    };
    this.loadData = this.loadData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { sessionParams } = this.props;
    const { sessionParams: previousSessionParams } = prevProps;

    if (sessionParams.currentAcademicPeriod != previousSessionParams.currentAcademicPeriod) {
      await this.loadData();
    }
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {


    const { dependentId, studentId } = this.props.match.params;
    const { sessionParams } = this.props;
    let dependentName = "";
    let dependentRegistration = "";
    let responsibleInfo = {};

    this.setState({ loading: true });

    if (sessionParams.currentAcademicPeriod) {
      let academicPeriodId = parseInt(sessionParams.currentAcademicPeriod);

      await studentsService.findById(studentId).then((studentResult) => {
        let studentHandledResult = handleResultData(studentResult);

        dependentName = studentHandledResult.person?.name;
        dependentRegistration = studentHandledResult.registration;
      });

      await responsiblesService.search({ dependentId: [dependentId], academicPeriodId: [academicPeriodId] }).then((result) => {
        responsibleInfo = handleResultData(result);

      });
      this.setState({ data: responsibleInfo, dependentName: dependentName, dependentRegistration: dependentRegistration, academicPeriodId: academicPeriodId, loading: false });
    } else {
      this.setState({ error: true, loading: false, message: "Não foi possível carregar as informações dos responsáveis..." });
    }

  }

  openPersonLookUpModal = () => {
    this.setState({ showPersonLookUpModal: true });
  }

  closePersonLookUpModal = () => {
    this.setState({ showPersonLookUpModal: false });
  }

  openModal = (id) => {
    this.setState({ targetDeleteId: id, showConfirmModal: true });
  }

  closeModal = () => {
    this.setState({ showConfirmModal: false, targetDeleteId: null });
  }

  deleteItem = () => {
    const { loadData } = this;
    if (this.state.targetDeleteId) {
      this.setState({ loading: true, actionLoading: true });
      responsiblesService.remove(this.state.targetDeleteId).then((result) => {
        this.setState({ loading: false, actionLoading: false, targetDeleteId: null, showConfirmModal: false }, () => {
          loadData();
        });
      });
    }
  }

  render() {
    let { dependentId, studentId } = this.props.match.params;
    let { history } = this.props;

    const { loading, actionLoading, error, message, data, showConfirmModal, showPersonLookUpModal, dependentName, dependentRegistration, academicPeriodId } = this.state;

    const { deleteItem, closeModal, openModal, openPersonLookUpModal, closePersonLookUpModal } = this;
    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && error === false && data.length <= 0 && <PageAlert className="m-b-20" message={"Sem informações"} description={"Não há dados para exibir no momento..."} type="info" dismissible />}
        {loading === false && (
          <Container>
            <Row>
              <h4>Listagem de responsáveis
                <AddButton
                  containerProps={{
                    onClick: () => openPersonLookUpModal()

                  }}
                />
              </h4>
              <h5>Aluno: {dependentRegistration} -  {dependentName}</h5>
              <Container>
                <Table className="mt-4">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>CPF/CNPJ</th>
                      <th>Nome</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 && data.map((element, index) => {
                      return (
                        <tr key={element.id}>
                          <td>{element.id}</td>
                          <td>{element.person?.documentField}</td>
                          <td>{element.person?.name}</td>
                          <td className="text-end">
                            <DropdownMenu
                              items={[
                                { type: DROPDOWN_MENU_TYPE_ITEM, title: <><PersonLock /> Ver dados de acesso</>, props: { as: Link, to: `/responsaveis/acesso/${element.id}/${dependentId}/${studentId}` } },
                                { type: DROPDOWN_MENU_TYPE_DIVIDER },
                                { type: DROPDOWN_MENU_TYPE_ITEM, title: <EditItemTitle />, props: { as: Link, to: `/responsaveis/editar/${element.id}/${dependentId}/${studentId}/${academicPeriodId}` } },
                                { type: DROPDOWN_MENU_TYPE_ITEM, title: <RemoveItemTitle />, props: { onClick: () => openModal(element.id) } }
                              ]}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Container>
              <div className="mt-3">
                <CancelButton
                  containerProps={{
                    as: Link,
                    to: `/alunos`
                  }}
                />
              </div>
            </Row>
            {showPersonLookUpModal == true && (
              <ResponsiblesLookUpModal
                show={showPersonLookUpModal}
                onClose={closePersonLookUpModal}
                modalTitle={"Cadastro de responsáveis"}
                baseRedirectUrl={`/responsaveis/adicionar/${dependentId}/${studentId}/${academicPeriodId}`}
                studentId={studentId}
                dependentId={dependentId}
                dependentName={dependentName}
                dependentRegistration={dependentRegistration}
                academicPeriodId={academicPeriodId}
                history={history}
              />)
            }
            {showConfirmModal == true && (
              <PageModal
                show={showConfirmModal}
                onClose={closeModal}
                onConfirm={deleteItem}
              />)
            }

          </Container>
        )}
      </div>
    );
  };
}

//Configs Redux para este component
//
//Define quais atributos vou pegar do
//state do Redux
const mapStateToProps = (state) => {
  const { data } = state.sessionParams;
  return { sessionParams: data };
};


//Define quais ações esse component
//vai usar para interagir com o Redux
const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(ResponsibleMain);
